(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wrs-gift-card-search-range"] && !Shopify.designMode) return;
  try {
    (() => {
    function initializeGiftCardRange() {
      const config = document.getElementById('wrs-gift-card-search-range');

      if (
        !config ||
        config.dataset.productId !== '4489995911265' ||
        config.dataset.wrsGiftCardRangeReady === 'true'
      ) {
        return;
      }

      const priceRange = config.dataset.priceRange;
      if (!priceRange) return;

      config.dataset.wrsGiftCardRangeReady = 'true';

      const instantCardSelector = '#snize-ac-product-4489995911265';
      const resultsCardSelector = '#snize-product-4489995911265';
      let listenersBound = false;

      function updateCard(card) {
        card.querySelectorAll('.snize-price').forEach((price) => {
          const textNodes = Array.from(price.childNodes).filter(
            (node) => node.nodeType === Node.TEXT_NODE
          );

          if (textNodes.length) {
            if (textNodes[0].nodeValue !== priceRange) {
              textNodes[0].nodeValue = priceRange;
            }

            textNodes.slice(1).forEach((node) => {
              if (node.nodeValue) node.nodeValue = '';
            });
          } else {
            price.prepend(document.createTextNode(priceRange));
          }
        });
      }

      function updateContainer(container, selector) {
        const root = container && (container[0] || container);
        if (!root || typeof root.querySelectorAll !== 'function') return;

        if (typeof root.matches === 'function' && root.matches(selector)) {
          updateCard(root);
        }

        root.querySelectorAll(selector).forEach(updateCard);
      }

      function updateExistingCards() {
        document.querySelectorAll('.snize-ac-results').forEach((container) => {
          updateContainer(container, instantCardSelector);
        });

        document.querySelectorAll('.snize-search-results').forEach((container) => {
          updateContainer(container, resultsCardSelector);
        });
      }

      function connectSearchanise() {
        const searchaniseJQuery = window.Searchanise && window.Searchanise.$;
        if (listenersBound || typeof searchaniseJQuery !== 'function') return;

        const events = searchaniseJQuery(document);

        events.on(
          'Searchanise.AutocompleteUpdated.wrsGiftCardRange',
          (event, input, container) => updateContainer(container, instantCardSelector)
        );

        events.on(
          'Searchanise.ResultsUpdated.wrsGiftCardRange',
          (event, container) => updateContainer(container, resultsCardSelector)
        );

        listenersBound = true;
        updateExistingCards();
      }

      document.addEventListener('Searchanise.Loaded', connectSearchanise);
      connectSearchanise();
      updateExistingCards();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeGiftCardRange, { once: true });
    } else {
      initializeGiftCardRange();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
